import { render, staticRenderFns } from "./cross_city_selection.vue?vue&type=template&id=2c6580a2&scoped=true&"
import script from "./cross_city_selection.vue?vue&type=script&lang=js&"
export * from "./cross_city_selection.vue?vue&type=script&lang=js&"
import style0 from "./cross_city_selection.vue?vue&type=style&index=0&id=2c6580a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6580a2",
  null
  
)

export default component.exports